var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'stacks-on-stacks': _vm.hasStacks }},_vm._l((_vm.portals),function(portal){return _c('portal-target',{key:portal.key,attrs:{"name":portal.key}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }